module.exports = __webpack_public_path__ + "img/jibaboom_astronomia_canvas.c74667a7.png";